import moment from 'moment'

export const durationFinder = (time: any) => {
  var now = moment()
  var then = moment(Date.parse(time))
  var duration = moment.duration(now.diff(then))
  var year = Math.floor(duration.asYears())
  var months = Math.floor(duration.asMonths())
  var weeks = Math.round(duration.asWeeks())
  var days = Math.round(duration.asDays())
  var hours = Math.floor(duration.asHours())
  var minutes = Math.floor(duration.asMinutes())
  var seconds = Math.floor(duration.asSeconds())
  console.log('seconds', +duration.asSeconds())
  if (seconds >= 1 && seconds < 61) {
    return `${seconds} secs`
  } else if (minutes >= 1 && minutes < 61) {
    return `${minutes} mins`
  } else if (hours >= 1 && hours < 25) {
    return `${hours} hrs`
  } else if (days >= 1 && days < 8) {
    return `${days} days`
  } else if (weeks >= 1 && weeks < 5) {
    return `${weeks} wks`
  } else if (months >= 1 && months < 13) {
    return `${months} months`
  } else if (year >= 1 && year < 100) {
    return `${year} yrs`
  } else {
    return time?.split(' ')[0]
  }
}
